import type { TRuleWithTheme } from '@/styles/theme';

export const modalContainer: TRuleWithTheme = () => ({
    '& .ant-modal .ant-modal-container': {
        padding: 0,
    },
});

export const contentContainer: TRuleWithTheme = () => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '1.25rem',

    height: '100%',

    padding: '1.5rem',
    paddingTop: '1.75rem',

    overflow: 'hidden',
});
